import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageCircle, Smartphone, Loader2, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import api from '@/utils/api';

export const ProspectWhatsAppActions = ({ p }) => {
  const { t, i18n } = useTranslation();
  const [links, setLinks] = useState(null);
  const [error, setError] = useState(null);
  const [retry, setRetry] = useState(0);
  const lang = ['pt', 'en', 'fr'].includes(i18n.language.slice(0, 2)) ? i18n.language.slice(0, 2) : 'pt';
  const pref = p.contact_preference;
  const phone = pref?.phone || p.phone;
  const enabled = ['whatsapp', 'call'].includes(pref?.channel);
  useEffect(() => {
    if (!enabled) return undefined;
    const controller = new AbortController();
    setLinks(null); setError(null);
    api.get(`/admin/prospects/${p.id}/whatsapp-links`, { params: { lang }, signal: controller.signal })
      .then(({ data }) => { if (!controller.signal.aborted) setLinks(data); })
      .catch((e) => { if (!controller.signal.aborted) setError(e?.response?.status === 422 ? 'invalidPhone' : 'loadError'); });
    return () => controller.abort();
  }, [p.id, phone, pref?.contact_name, pref?.channel, p.schedule_confirmation?.confirmed_at, enabled, lang, retry]);
  if (!enabled) return null;
  if (error) return <div className="basis-full flex flex-wrap gap-2 items-center" role="alert" data-testid={`prospect-whatsapp-error-${p.id}`}>
    <span className="text-xs text-amber-800" data-testid={`prospect-whatsapp-error-message-${p.id}`}>{t(`prospects.whatsapp.${error}`)}</span>
    {error !== 'invalidPhone' && <Button size="sm" variant="outline" onClick={() => setRetry((v) => v + 1)} data-testid={`prospect-whatsapp-retry-${p.id}`}><RefreshCw className="h-3.5 w-3.5 mr-1" />{t('prospects.whatsapp.retry')}</Button>}
  </div>;
  if (!links) return <Button size="sm" disabled variant="outline" data-testid={`prospect-whatsapp-loading-${p.id}`}><Loader2 className="h-4 w-4 animate-spin mr-1" />WhatsApp</Button>;
  return <>
    <Button size="sm" asChild className="bg-emerald-600 hover:bg-emerald-700 text-white max-w-full h-auto min-h-9 whitespace-normal text-left">
      <a href={links.web_url} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer" data-testid={`prospect-action-whatsapp-${p.id}`}><MessageCircle className="h-4 w-4 mr-1 shrink-0" />{t('prospects.whatsapp.openWeb')}</a>
    </Button>
    <Button size="sm" variant="outline" asChild className="max-w-full h-auto min-h-9 whitespace-normal text-left">
      <a href={links.mobile_url} target="_blank" rel="noopener noreferrer" referrerPolicy="no-referrer" data-testid={`prospect-action-whatsapp-app-${p.id}`}><Smartphone className="h-4 w-4 mr-1 shrink-0" />{t('prospects.whatsapp.openApp')}</a>
    </Button>
  </>;
};